// extracted by mini-css-extract-plugin
export var bar = "reccomendedProducts-module--bar--1428c";
export var productSliderTitle = "reccomendedProducts-module--product-slider-title--b2912";
export var reccomendedProducts = "reccomendedProducts-module--reccomendedProducts--09b94";
export var slickDots = "reccomendedProducts-module--slick-dots--14d05";
export var slickSlider = "reccomendedProducts-module--slick-slider--414f9";